import React from 'react';
import classnames from 'classnames';
import SendGridLink from '../../SendGridLink';
import { StyledColumnHeader } from './styles';

const ColumnHeader = ({ title, subtitle, url }) => (
  <StyledColumnHeader>
    <h4>
      <SendGridLink to={url} dangerouslySetInnerHTML={{ __html: title }} />
    </h4>
    <p dangerouslySetInnerHTML={{ __html: subtitle }} />
  </StyledColumnHeader>
);

export default ColumnHeader;
